export default process.env.LIGHTING_API_BASE ||
  (process.env.NODE_ENV === "production"
    ? "/api/lighting/"
    : "http://localhost:57886/");
